import type { GroupBase, Props } from "react-select";
import ReactSelect from "react-select";

export const Select = <
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>(
  props: Props<Option, IsMulti, Group>
) => {
  return (
    <ReactSelect
      classNames={{
        control: () =>
          "border !border-divider-main rounded-md h-12 whitespace-nowrap overflow-hidden"
      }}
      {...props}
    />
  );
};
